import React from 'react';
import PropTypes from 'prop-types';

import { EMOJI_SET } from '../../utils/emoji';

const propTypes = {

	emoji: PropTypes.shape({

		/**
		 * An emoji ID, i.e. "+1".
		 */
		id: PropTypes.string,

		/**
		 * An emoji name, i.e. "Thumbs Up".
		 */
		name: PropTypes.string,

		/**
		 * An emoji shortcode, i.e. ":+1::skin-tone-2:".
		 */
		shortcodes: PropTypes.string,

		/**
		 * DEPRECATED
		 *
		 * Renamed to "shortcodes" in emoji-mart@v5.
		 */
		colons: PropTypes.string,

		/**
		 * A native emoji.
		 */
		native: PropTypes.string,

		/**
		 * A unified format emoji.
		 */
		unified: PropTypes.string,

	}).isRequired,

	/**
	 * The inline element size.
	 */
	size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

};

const defaultProps = {
	size: '24px',
};


/**
 * Shared component to render an emoji.
 *
 * @param {Object} props The props.
 *
 * @returns {Object} The rendered component.
 */
const EmojiRenderer = (props) => {

	const {
		emoji,
		size,
	} = props;

	if (!emoji) {
		return null;
	}

	return (
		<em-emoji
			{...emoji}
			size={size}
			set={EMOJI_SET} />
	);

};

EmojiRenderer.defaultProps = defaultProps;
EmojiRenderer.propTypes = propTypes;

export default EmojiRenderer;
